<script>

import {DateTime} from "luxon";

export default {
  name: 'tab',
  props: ["voteGroup"],
  data: function () {
    return {
      time_created: null
    }
  },
  mounted() {
    this.time_created = new Date();
    // console.log(this.voteGroup.name + " created");
  },
  methods: {
    cant() {
      this.voteGroup.status = "CANT";
      for (let k of Object.keys(this.voteGroup.values)) {
        this.voteGroup.values[k] = null;
      }
      this.finalize();
    },
    dontKnow(){
      this.voteGroup.status = "DKNO";
      for (let k of Object.keys(this.voteGroup.values)) {
        this.voteGroup.values[k] = null;
      }
      this.finalize();
    },
    done() {
      // console.log("tab.done()")
      this.voteGroup.status = "DONE"
      this.finalize()
    },
    finalize() {
      this.voteGroup.millis = new Date() - this.time_created.getTime();
      this.voteGroup.when = DateTime.now().toString()
      this.$emit("tabComplete", this.voteGroup.name)
    }

  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.on {
  color: red
}

.off {
  color: black
}
</style>
